/* Klaviyo form submit → Meta Pixel "Lead".

   Preferred home for this is the GTM container (GTM-WD3KC9SB), which already
   owns pixel 590029450405397 — see plans/klaviyo-fb-lead.md. This file is the
   theme-side fallback for when GTM access isn't available.

   Notes (do not deviate):
   - fbq is NOT loaded by this theme. Two Meta pixels initialise it on window:
       839086541137930 — Facebook & Instagram sales channel web pixel
                         (runtimeContext OPEN, so it shares window.fbq)
       590029450405397 — injected by the GTM container
     A bare fbq('track', ...) fires to BOTH. That is a deliberate call (see the
     plan doc) — it is not double-counting, and the FB channel sends no server-side
     Lead to collide with. To scope it to one pixel later:
     fbq('trackSingle', '<id>', 'Lead').
   - The fbq guard is load-bearing. connect.facebook.net is blocked by most
     ad blockers, and without the guard every form submit throws a
     ReferenceError in those sessions.
   - klaviyoForms fires 'stepSubmit' per step on multi-step forms and 'submit'
     once on final submission. Only 'submit' is a Lead.
   - klaviyo.js is loaded site-wide by the Klaviyo app embed
     (config/settings_data.json). If that embed is removed, this silently breaks.
   - There are TWO live layouts. This must be script-tagged from both
     layout/theme.liquid and layout/theme.shogun.landing.liquid, or Shogun-built
     landing pages — the surface most likely to carry a capture form — fire nothing.
     Caveat: the Shogun layout is marked "Auto-generated by Shogun. This file can be
     re-written at any time." If Shogun regenerates it, that tag is lost silently.
     Re-check it after any Shogun upgrade. (The existing GTM snippet lives in the
     same file and has survived so far, but it is not a guarantee.)
   - Not gated on Shopify's Customer Privacy API, matching the existing hardcoded
     GTM snippet. If the store ever adds consent gating, this needs it too.
*/

(function () {
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'submit') return;

    // Pixel blocked, or GTM/the FB channel hasn't initialised it yet.
    if (typeof window.fbq !== 'function') return;

    window.fbq('track', 'Lead');
  });
})();
